/*
** A few functions functions to update "What's On Now" dynamically during navigation.
** These use the custom endpoint /res/won.php, which is a mirror of the 
** http://clients.webplaylist.org/cgi-bin/wfmt/won_v2.xml,
** in order to avoid intermittent Cross-Origin request issues.
**
** (This feed is defined above the WP root level at res/won.php)
*/

import { parseURL } from './utils'

function UpdateWhatsOnNow () {

    /*
    ** Updates the header and sidebar WON (#wfmt-won-3, #wfmt-won-3)
    ** Manually reconstructs all the semantic HTML built by the theme,
    ** with updated information.
    */

    fetch('/res/won.php').
        then( (result) => result.text()).
        then( (text) => {
          try {
            var j = JSON.parse(text);
            return j;
          } catch (e) {
              return null;
          }
        }).then ( (jsonResult) => {   

            if (! jsonResult) {return; }

          var won2 = `<h4 class="h-widget">What’s Playing Now</h4>`;
            var won3 = '';

            if ( jsonResult['show'] && jsonResult['show']['title'] ) {
                
                won2 += `<h3 class="showtitle mtn">`;
                won3 += '<h5 class="now-playing mvn">';
                if ( jsonResult['show']['main_link'] ) {
                    
                    won2 += `<a href="`+ parseURL(jsonResult['show']['main_link']).pathname+`" 
                              class="internal-link">`; 

                    won3 += `<a href="`+ parseURL(jsonResult['show']['main_link']).pathname+ `" class="showtitle"
                              data-cturl="` + parseURL(jsonResult['show']['main_link']).pathname+`">`;
                }
                    
                won2 += jsonResult['show']['title']
                won3 += jsonResult['show']['title']

                if (jsonResult['show']['main_link'] ) {
                  won2 += `</a>`;
                  won3 += `</a>`;
                }              
              
              won2 += `</h3>`;
              won3 += `</h5>`;                           
            }
              if ('track' in jsonResult && jsonResult['track'] != null) {

                  var Composer = jsonResult['track']['composer'] || '';
                  var Title = jsonResult['track']['title'] || '';
                  var Orchestra = jsonResult['track']['orchestra'] || '';
                  var Title = jsonResult['track']['title'] || '';
                  var Soloists = jsonResult['track']['soloists'] ? jsonResult['track']['soloists'].join(" | ") : '';

                  if ( Title ) {
                    won2 += `<p class="now-playing stacked"><strong>` 
                        + Title + `</strong><br>`
                    won3 += '<p class="now-playing horiz"><strong>'+Title+'</strong>';
                  }
                  if ( Orchestra ) {
                    won2 += `<span class="divider"> | </span>` + Orchestra;
                    won3 += ' | ' + Orchestra;
                  }
                  if ( Composer ) {
                    won2 += `<span class="divider"> | </span>` + Composer;
                    won3 += ' | ' + Composer;
                  }
                  if ( Soloists) {
                    won2 += `<span class="divider"> | </span>` + Soloists;
                    won3 += ' | ' + Soloists;
                  }
                  won2 += '</p>';
                  won3 += '</p>';
                }

            jQuery('div#wfmt-won-3').html(won3);              
            jQuery('div#wfmt-won-2').html(won2);   
       
    });
  }

  function refreshSchedule() {

    /**
     *  Refreshes the entire schedule for when the user remains on the 
     *  "Schedule" page
     *  Uses a custom endpoint defined above the WP level at res/schedule-request.php,
     *  a mirror of http://webplaylist.org/cgi-bin/wfmt/playlist-wfmt.cgi that avoids
     *  intermittent Cross-Origin request errors.     
     */

    fetch('/res/schedule-request.php').
        then( function(result) {
            return result.text();
        }).
        then( function (text) {
            text = text.replace("↵", "");
            var newHTML = jQuery(text);
            var playListMain = jQuery('#playlist-main', newHTML).html();
            jQuery('#playlist-main').html(playListMain);
          
        });
}

function continuouslyRefreshSchedule(callback) {
    
    refreshSchedule(); 
    var scheduleUpdate = setInterval( function () {
        refreshSchedule();
        callback();
    }, 15000);

    return scheduleUpdate;
}



  export { UpdateWhatsOnNow, continuouslyRefreshSchedule };